import { useActiveRole } from 'App/context/ActiveRoleContext';
import { useUser } from 'store/hooks/useUser';
import Footer from './Footer';

const FooterContainer = props => {
  const user = useUser();
  const { activeRole, setActiveRole } = useActiveRole();

  return <Footer {...props} user={user} activeRole={activeRole} setActiveRole={setActiveRole} />;
};

export default FooterContainer;
